import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import { brand, navItems, coreServices } from '@/mocks/site';

export default function Footer() {
  const services = [...coreServices.map((s) => s.title), 'Administrative & Financial Coordination'];
  return (
    <footer className="bg-[linear-gradient(to_top,#A3C4E2_0%,#C9DCEE_45%,#FFFFFF_100%)]">
      <Container>
        <div className="grid grid-cols-1 gap-10 py-14 md:grid-cols-2 md:py-16 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-4">
            <Link to="/" className="cursor-pointer font-heading text-[19px] font-bold tracking-[0.12em] text-foreground-950">{brand.name}</Link>
            <p className="mt-4 max-w-[320px] text-[15px] leading-[1.6] text-foreground-700">
              Residential community property management for condominiums, apartment communities and planned neighborhoods.
            </p>
          </div>
          <nav aria-label="Footer" className="lg:col-span-2">
            <h4 className="font-label text-[13px] font-semibold uppercase tracking-[0.12em] text-foreground-600">Pages</h4>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((n) => (
                <li key={n.to}><Link to={n.to} className="cursor-pointer text-[15px] text-foreground-950 hover:text-accent-500">{n.label}</Link></li>
              ))}
            </ul>
          </nav>
          <div className="lg:col-span-3">
            <h4 className="font-label text-[13px] font-semibold uppercase tracking-[0.12em] text-foreground-600">
              <Link to="/services" className="cursor-pointer hover:text-accent-500">Services</Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {services.map((s) => (
                <li key={s} className="text-[15px] text-foreground-950">{s}</li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h4 className="font-label text-[13px] font-semibold uppercase tracking-[0.12em] text-foreground-600">Get in touch</h4>
            <p className="mt-4 text-[15px] leading-[1.6] text-foreground-700">
              Boards and owners can request a proposal. Residents can send a support inquiry through the same page.
            </p>
            <div className="mt-4 flex flex-col gap-2">
              <Link to="/contact?type=partnership" className="cursor-pointer text-[15px] font-semibold text-accent-500 hover:text-accent-700">Request a Proposal</Link>
              <Link to="/contact?type=resident" className="cursor-pointer text-[15px] font-semibold text-accent-500 hover:text-accent-700">Resident Support</Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 border-t border-foreground-950/10 py-6 text-[13px] text-foreground-600 sm:flex-row sm:justify-between">
          <p>© 2026 {brand.name}. All rights reserved.</p>
          <p>{brand.descriptor}</p>
        </div>
      </Container>
    </footer>
  );
}